import { useState } from 'react';
import { FormTitle, TextArea } from '@molecules/TextArea/TextArea';
import { NavigationButtons } from '@molecules/TextArea/TextArea';
import { useNavigate } from 'react-router-dom';
import { RoutesList } from '../../../../routes/Routes';
import { usePlanningBreachStore } from '../../../../hooks/usePlanningBreachStore';
import { ErrorMessages } from '@types';
import { parseZodErrors } from '@utils';
import { ZodError } from 'zod';
import { ErrorSummary } from '@atoms/ErrorSummary/ErrorSummary';
import { issueSchema } from '../../../../validations';

const issueInfoLabelText = 'What works are being carried out?';
const issueInfoDescription = 'For example, demolition or building works.';

const locationOfIssueInfoLabelText = 'Where are the works being done?';
const locationOfIssueInfoDescription =
  'For example, works being done in the basement or on the roof.';

export const TellUsMoreWorks = () => {
  const { data, update } = usePlanningBreachStore();
  const navigate = useNavigate();
  const formTitle = 'Tell us about the issue';
  const [errorMessages, setErrorMessages] = useState<ErrorMessages[]>([]);

  const handleChangeissueInfo = (
    event: React.ChangeEvent<HTMLTextAreaElement>,
  ) => {
    update('issueInfo', event.currentTarget.value);
    setErrorMessages([]);
  };

  const handleChangeLocationOfIssueInfo = (
    event: React.ChangeEvent<HTMLTextAreaElement>,
  ) => {
    update('locationOfIssueInfo', event.currentTarget.value);
    setErrorMessages([]);
  };

  const buttonNext = {
    onClick: () => {
      try {
        issueSchema.parse({
          locationOfIssueInfo: data.locationOfIssueInfo,
          issueInfo: data.issueInfo,
        });
        navigate(RoutesList.WORKS_RESPONSIBILITY);
      } catch (error) {
        const validationErrors = parseZodErrors(error as ZodError);
        setErrorMessages(
          validationErrors.map((error: ErrorMessages) => ({
            ...error,
            href: error.path,
          })),
        );
      }
    },
  };

  const buttonPrevious = {
    label: 'Previous',
    onClick: () => navigate(RoutesList.WORKS_COMPLETED_DATE),
  };

  return (
    <>
      <FormTitle text={formTitle} />
      <ErrorSummary messages={errorMessages} />
      <TextArea
        labelText={issueInfoLabelText}
        isLabelTextTitle={false}
        description={issueInfoDescription}
        value={data.issueInfo}
        onChange={handleChangeissueInfo}
        errorPath={'issueInfo'}
        errorMessages={errorMessages}
      />
      <TextArea
        labelText={locationOfIssueInfoLabelText}
        isLabelTextTitle={false}
        description={locationOfIssueInfoDescription}
        value={data.locationOfIssueInfo}
        onChange={handleChangeLocationOfIssueInfo}
        errorPath={'locationOfIssueInfo'}
        errorMessages={errorMessages}
      />
      <NavigationButtons
        buttonNext={buttonNext}
        buttonPrevious={buttonPrevious}
      />
    </>
  );
};
